import { filter, propEq } from 'ramda'
import { useQuery } from 'react-query'

import { AccountsAPI } from 'api'
import { AttributeDefinition } from 'types/account'

const getAccountAttributes = (url: string) =>
  AccountsAPI.get<AttributeDefinition[]>('/attrib').then((res) =>
    filter(propEq('deleted', false), res.data)
  )

export const useAccountAttributes = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['account_attributes'],
    queryFn: ({ queryKey }) => getAccountAttributes(queryKey[0]),
    refetchOnWindowFocus: false,
  })

  return {
    data,
    isLoading,
    error,
  }
}

export default useAccountAttributes
